import React, { Component } from 'react';
import tipAlert from '../../../Login/BsyAlertTip/Staticize';
import BsySLoading from '../../BsySLoading';
import { BsyUtils } from '../../../utils/Utils';
import { BsyConfig } from '../../../global/BsyConfig';
import icon1 from '../../../images/dash/img_dingwei1.png';
import icon2 from '../../../images/dash/img_dingwei2.png';
import icon3 from '../../../images/dash/mark_y.png';

import './index.css';
import BsyMaskLayer from '../../BsyMaskLayer';
import BsyFormPane from '../../BsyFormPane';
import BsyAlert from '../../BsyAlert';

class BsyDashMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            LngLats: [],
            dataWindowOpen: false,
            addressData: [],
            dataList: [],
            headerList: [],
            fields: props.fields,
            defaultSort: props.defaultSort ? props.defaultSort : props.sort,
            searchRes: {},
            searchMapList: [],
            page: 0,
            markerList: [],
            limit: 10,
            isLoading: true,
            addressList: [],
            hasAMap: true,
        };
        this.map = {};
        this.AMap = {};
        this.searchMark = null;
        this.searchInput = React.createRef();
        window.zIndex++
    }

    getLocation = () => {

    }

    mapMarker = () => {
        this.map.on('click', (res) => {
            this.infoWindow && this.infoWindow.close();
            let searchRes = {};
            const AMap = this.AMap;
            if (this.searchMark) {
                this.searchMark.setMap(null);
                this.searchMark = null;
            }
            this.searchMark = new AMap.Marker({
                position: [res.lnglat.lng, res.lnglat.lat],
                map: this.map,
                anchor: "bottom-center",
                icon: icon3
            })
            this.infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -23), direction: "top" });
            this.MGeocoder.getAddress(this.searchMark.getPosition(), (status, result) => {
                if (status === 'complete' && result.regeocode) {
                    let lng = this.searchMark.getPosition().lng;
                    let lat = this.searchMark.getPosition().lat;
                    let pos = React.language("latLon.marked", { lngNum: lng, latNum: lat });
                    searchRes.city = result.regeocode.addressComponent.city;
                    searchRes.detail = (result.regeocode.pois.length > 0 ? result.regeocode.pois[0].address : "") + (result.regeocode.pois.length > 0 ? result.regeocode.pois[0].name : "");
                    searchRes.district = result.regeocode.addressComponent.district;
                    searchRes.province = result.regeocode.addressComponent.province;
                    searchRes.lnglatXY = [lng, lat];

                    this.searchMark.content = "<p>" + pos + "</p>" + "<p>" + React.language("address") + result.regeocode.formattedAddress + "</p>";
                } else {
                    console.error(React.language('latLon.not.exist'), status, result)
                    tipAlert({
                        type: "error",
                        msg: React.language("latLon.not.exist")
                    });
                }
            });
            this.searchMark.on('click', (e) => {
                this.infoWindow.setContent(e.target.content);
                this.infoWindow.open(this.map, e.target.getPosition());
            });
            this.setState({ searchRes, searchMapList: [] })
        })
    }

    initMarkers = () => {
        let type = '';
        const { dataList } = this.state;
        let tag = '';
        if (this.props.mapfields && this.props.mapfields.length > 0) {
            tag = this.props.mapfields[0].tag;
            type = this.props.mapfields[0].type
        } else {
            return
        }
        let LngLats = [];
        if (type === 'address') {
            let { addressList, addressData } = this.state
            let num = 0;
            let addressLength = dataList.length
            dataList.map((res, key) => {
                if (res[tag]) {
                    if (res[tag].lnglatXY) {
                        LngLats[key] = res[tag].lnglatXY;
                        addressLength--
                        if (num >= addressLength) {
                            this.setState({ isLoading: false, LngLats }, () => {
                                this.mapDriving();
                            })
                        }
                    } else {
                        let address = res[tag].province + res[tag].city + res[tag].district + res[tag].detail
                        addressLength--
                        this.MGeocoder.getLocation(address, (status, result) => {
                            if (status === 'complete' && result.info === 'OK') {
                                // result中对应详细地理坐标信息
                                addressLength++
                                num++
                                let lnglat = result.geocodes[0].location
                                LngLats[key] = [lnglat.lng, lnglat.lat];
                                addressData[key] = dataList[key]
                                if (num >= addressLength) {
                                    this.setState({ isLoading: false, LngLats }, () => {
                                        this.mapDriving();
                                    })
                                }
                            } else {
                                // console.log(result)
                                LngLats[key] = [-1000, -1000];
                                if (num >= addressLength) {
                                    this.setState({ isLoading: false, LngLats }, () => {
                                        this.mapDriving();
                                    })
                                }
                            }
                        })
                    }
                } else {
                    LngLats[key] = [-1000, -1000];
                    addressLength--
                    if (num >= addressLength) {
                        this.setState({ isLoading: false, LngLats }, () => {
                            this.mapDriving();
                        })
                    }
                }
            })
        } else if (type === 'location') {
            dataList.map((res, key) => {
                if (res[tag]) {
                    if (res[tag].lnglatXY) {
                        LngLats[key] = res[tag].lnglatXY;
                    } else {
                        LngLats[key] = [-1000, -1000];
                    }
                } else {
                    LngLats[key] = [-1000, -1000];
                }
            })
            this.setState({ isLoading: false, LngLats }, () => {
                this.mapDriving();
            })
        } else {
            if (this.props.mapfields[0].type === 'text') {
                dataList.map((res) => {
                    if (res[tag]) {
                        let lnglat = res[tag].split(',');
                        if (lnglat.length > 1) {
                            LngLats.push(lnglat)
                        } else {
                            LngLats.push([-1000, -1000])
                        }
                    } else {
                        LngLats.push([-1000, -1000])
                    }
                })
            }

            this.setState({ isLoading: false, LngLats }, () => {
                this.mapDriving();
            })
        }
    }
    // 2.dom渲染成功后进行map对象的创建
    initMap = () => {
        this.AMap = window.AMap;
        if (this.AMap) {
            const AMap = this.AMap;
            this.map = new AMap.Map("DashMap-" + window.zIndex, { //设置地图容器id
                // viewMode: "3D",         //是否为3D地图模式
                resizeEnable: true,
                animateEnable: false,
                zooms: [5, 20],
                zoom: this.props.mapScale || 5,                //初始化地图级别
                // center: [105.602725, 37.076636], //初始化地图中心点位置
            });

            // for(let i = 0; i< 16 ; i++) {
            //     var num1=Math.random()*0.1+112.9;
            //     var num2=Math.random()*0.1+28.2;
            //     LngLats.push([num1,num2])
            // }
            this.mapCenter = this.map.getCenter()
            AMap.plugin(['AMap.Geocoder'], () => { //回调函数
                if (!this.MGeocoder) {
                    this.MGeocoder = new AMap.Geocoder({
                        radius: 100,
                        extensions: "all"
                    });
                }
            });

            // this.loadData();
            this.mapMarker();
        } else {
            this.setState({
                hasAMap: false
            })
        }
    }

    componentDidMount() {
        if (this.props.getContext) {
            this.props.getContext(this);
        }
        this.initMap()
    }

    reload = () => {
        this.loadData(!0)
    }

    getFilterData = (t) => {
        let e = this.props
            , i1 = BsyUtils.applyFunc(this, e.onDataFilter, [], !1)
            , a = [];
        let i = i1.filter;
        this.filterMap = i1.filterMap;
        i && (a = a.concat(i))
        BsyUtils.isObjectEmpty(t) || (a = a.concat(t))
        e.filter && "visit" !== e.mode && (a = a.concat(e.filter.cond))
        return BsyUtils.isObjectEmpty(a) ? {} : {
            cond: a,
            rel: i1.rel || BsyConfig().CONST.FILTER_RELATION.AND
        }
    }

    _getAsyncConfig = (e) => {
        let i, a, n = this.props;
        const { limit, page } = this.state;
        if ("visit" !== n.mode) {
            i = n.url || "/data/report_preview_map_list";
            a = {
                // widgetId: n.widgetName,
                widget: {
                    fields: n.fields,
                    forms: n.forms,
                    mapfields: n.mapfields,
                    mapScale: n.mapScale,
                    scopefields: n.scopefields,
                    filter: this.getFilterData(n.filter),
                    hasHeader: !0,
                    bgColorFilter: n.bgColorFilter,
                    dynamicField: n.dynamicField,
                    defaultSort: n.defaultSort
                },
                appId: n.appId,
                entryId: n.entryId,
                sort: n.defaultSort ? n.defaultSort.slice(0) : {},
                // skip: page * limit,
                // limit: limit,
                rowOrder: n.rowOrder,
                top: n.top,
                hasCount: e,
                isCountOnly: e,
                popupFormPath: n.popupFormPath,
            }
            this.hasSort && (a.widget.defaultSort = n.defaultSort)
        }
        else {
            i = "/data/report_map_list";
            a = {
                widgetId: n.widgetId,
                appId: n.appId,
                entryId: n.entryId,
                fields: n.fields,
                mapfields: n.mapfields,
                defaultSort: n.defaultSort,
                sort: n.defaultSort ? n.defaultSort.slice(0) : {},
                // skip: page * limit,
                // limit: limit,
                filter: this.getFilterData(n.filter),
                hasCount: e,
                popupFormPath: n.popupFormPath,
                isCountOnly: e,
            }
            // this.hasSort && (a.sort = this.dashSort.getSorts());
        }
        return {
            url: i,
            data: a
        }
    }

    loadWidget = (n, d, s) => {
        this.loadData(n, d, s);
    }

    loadData = (v) => {
        this.setState({
            isLoading: true,
        }, () => {
            setTimeout(() => {
                let data = this._getAsyncConfig()
                this.map.setCenter([this.mapCenter.lng, this.mapCenter.lat]);
                React.axios(data.url, data.data).then((res) => {
                    this.reftype = res.data.reftype
                    this.map.clearMap();
                    this.searchInput.current && (this.searchInput.current.value = "")
                    res.data.data.map((res1) => {
                        res1.locationSelect = false;
                    })
                    this.setState({
                        dataList: res.data.data,
                        headerList: res.data.header,
                        // isLoading: false,
                    }, () => {
                        // v && this.map.clearMap();
                        this.initMarkers();
                        if (this.props.onLoadSuccess) {
                            this.props.onLoadSuccess(res.data)
                        }
                    })
                }).catch((res) => {
                    if (this.props.onConfigError) {
                        if (res.status) {
                          this.props.onConfigError(res.data);
                        }
                      }
                })
            }, 30)
        })
    }

    hasDetail = false;

    mapDriving = () => {
        const AMap = this.AMap;
        const { LngLats, addressData, headerList, dataList } = this.state;
        const { scopefields } = this.props;
        if (LngLats.length <= 0) {
            return
        }
        let LngLatList = [];
        let waypointsList = [];
        let markerList = [];
        let circleList = [];
        this.map.clearMap();
        LngLats.map((res, key) => {
            LngLatList.push(new AMap.LngLat(res[0], res[1]))
            if (key !== 0 || key !== (LngLats.length - 1)) {
                waypointsList.push(new AMap.LngLat(res[0], res[1]))
            }
            let line = ``;
            let lineMass = ``;
            this.hasDetail = false;
            dataList.map((res1, key1) => {
                if (key === key1) {
                    headerList.map((res) => {
                        if (res.onlyDetail && !res.detailOnly) {
                            this.hasDetail = true;
                            let tag = res.tag;
                            let row = BsyUtils.transformDataSourceRow(res, res1[tag]);
                            if (!res1.hasOwnProperty(tag)) {
                                row = ""
                            }
                            let val = res.title + "：" + row;
                            line += `<div class="crad-cont">${BsyUtils.escapeHtmlSpecialChar(val)}</div>`;
                            lineMass += val + "\n"
                        }
                    })
                }
            })

            let content = `<div class="marker-route marker-marker-bus-from">${line}</div>`;
            let marker
            if (this.hasDetail) {
                marker = new AMap.Marker({
                    icon: icon1,
                    anchor: "bottom-center",
                    position: new AMap.LngLat(res[0], res[1]), // 基点位置
                    label: {
                        offset: new AMap.Pixel(0, -15), // 相对于基点的偏移位置
                        direction: "top",
                        content: content,  // 自定义点标记覆盖物内容
                    }
                });
            } else {
                marker = new AMap.Marker({
                    icon: icon1,
                    anchor: "bottom-center",
                    position: new AMap.LngLat(res[0], res[1]) // 基点位置
                });
            }


            let zIndex = marker.getzIndex();
            marker.on("click", (e) => {
                let activeLine = String(line);
                dataList.map((res) => {
                    res.locationSelect = false;
                    return null;
                })
                dataList[key].locationSelect = true;

                // this.map.panTo([res[0], res[1]]);
                markerList.map((res, key) => {
                    res.setIcon(icon1);
                    if (this.hasDetail) {
                        let cont = res.getLabel().content;
                        let scont = cont;
                        if (cont.split('class="marker-route marker-marker-bus-from active"').length > 1) {
                            scont = cont.split('class="marker-route marker-marker-bus-from active"').join('class="marker-route marker-marker-bus-from"')
                        }
                        res.setLabel({
                            offset: new AMap.Pixel(0, -15), // 相对于基点的偏移位置
                            direction: "top",
                            content: scont,  // 自定义点标记覆盖物内容
                        });
                    }
                    res.setzIndex(zIndex)
                    return null;
                })

                if (this.hasDetail) {
                    let content1 = `<div class="marker-route marker-marker-bus-from active">${activeLine}</div>`;
                    e.target.setLabel({
                        offset: new AMap.Pixel(0, -15), // 相对于基点的偏移位置
                        direction: "top",
                        content: content1,  // 自定义点标记覆盖物内容
                    });
                }
                e.target.setIcon(icon2);
                e.target.setzIndex(zIndex + 1);
                this._doShowData(key, 'newMap', true)
            })

            if (scopefields.length > 0) {
                if (res[0] > -500 && res[1] > -500) {
                    let circle = new AMap.Circle({
                        center: new AMap.LngLat(res[0], res[1]),
                        radius: parseInt(dataList[key][scopefields[0].tag]), //半径
                        borderWeight: 1,
                        strokeColor: "#0265ff",
                        strokeWeight: 1,
                        strokeOpacity: 1,
                        fillOpacity: 0.4,
                        strokeStyle: 'solid',
                        strokeDasharray: [10, 10],
                        // 线样式还支持 'dashed'
                        fillColor: '#0265ff',
                        zIndex: 50
                    });
                    circle.on('click', (res) => {
                        this.infoWindow && this.infoWindow.close();
                        let searchRes = {};
                        const AMap = this.AMap;
                        if (this.searchMark) {
                            this.searchMark.setMap(null);
                            this.searchMark = null;
                        }
                        this.searchMark = new AMap.Marker({
                            position: [res.lnglat.lng, res.lnglat.lat],
                            map: this.map,
                            anchor: "bottom-center",
                            icon: icon3
                        })
                        this.infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -23), direction: "top" });
                        this.MGeocoder.getAddress(this.searchMark.getPosition(), (status, result) => {
                            if (status === 'complete' && result.regeocode) {
                                let lng = this.searchMark.getPosition().lng;
                                let lat = this.searchMark.getPosition().lat;
                                let pos = React.language("latLon.marked", { lngNum: lng, latNum: lat });
                                searchRes.city = result.regeocode.addressComponent.city;
                                searchRes.detail = (result.regeocode.pois.length > 0 ? result.regeocode.pois[0].address : "") + (result.regeocode.pois.length > 0 ? result.regeocode.pois[0].name : "");
                                searchRes.district = result.regeocode.addressComponent.district;
                                searchRes.province = result.regeocode.addressComponent.province;
                                searchRes.lnglatXY = [lng, lat];

                                this.searchMark.content = "<p>" + pos + "</p>" + "<p>" + React.language("address") + result.regeocode.formattedAddress + "</p>";
                            } else {
                                console.error(React.language('latLon.not.exist'), status, result)
                                tipAlert({
                                    type: "error",
                                    msg: React.language("latLon.not.exist")
                                });
                            }
                        });
                        this.searchMark.on('click', (e) => {
                            this.infoWindow.setContent(e.target.content);
                            this.infoWindow.open(this.map, e.target.getPosition());
                        });
                        this.setState({ searchRes, searchMapList: [] })
                    })
                    circleList.push(circle)
                }
            }
            markerList.push(marker)
        })

        if (scopefields.length > 0) {
            this.map.add(circleList);
        }

        this.map.add(markerList);
        this.setState({ markerList, circleList })
    }

    onSearchMap = (e) => {
        const AMap = this.AMap;
        const current = e.currentTarget;
        let searchMapList = [];
        if (current.value !== "") {
            AMap.plugin('AMap.AutoComplete', () => {
                // 实例化Autocomplete
                var autoOptions = {
                    city: '全国'
                }
                var autoComplete = new AMap.Autocomplete(autoOptions);

                autoComplete.search(current.value, (status, result) => {
                    // 搜索成功时，result即是对应的匹配数据
                    // console.log(result)
                    if (result.info === "OK") {
                        searchMapList = result.tips;
                        this.setState({ searchMapList })
                    } else {
                        this.setState({ searchMapList: [] })
                    }

                })
            })
        } else {
            this.setState({ searchMapList: [] })
        }

    }

    setZoom = (res) => {
        return () => {
            if (res) {
                const AMap = this.AMap;
                if (this.searchMark) {
                    this.searchMark.setMap(null);
                    this.searchMark = null;
                }
                if (this.infoWindow) {
                    this.infoWindow.close();
                    this.infoWindow = null;
                }
                let searchRes = {};
                this.searchMark = new AMap.Marker({
                    position: [res.location.lng, res.location.lat],
                    map: this.map,
                    anchor: "bottom-center",
                    icon: icon3
                })
                this.searchInput.current.value = res.name;
                this.map.setZoomAndCenter(16, [res.location.lng, res.location.lat]);
                this.infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -23), direction: "top" });
                this.MGeocoder.getAddress(this.searchMark.getPosition(), (status, result) => {
                    if (status === 'complete' && result.regeocode) {
                        let lng = this.searchMark.getPosition().lng;
                        let lat = this.searchMark.getPosition().lat;
                        let pos = React.language("latLon.marked", { lngNum: lng, latNum: lat });
                        searchRes.city = result.regeocode.addressComponent.city;
                        searchRes.detail = (result.regeocode.pois.length > 0 ? result.regeocode.pois[0].address : "") + (result.regeocode.pois.length > 0 ? result.regeocode.pois[0].name : "");
                        searchRes.district = result.regeocode.addressComponent.district;
                        searchRes.province = result.regeocode.addressComponent.province;
                        searchRes.lnglatXY = [lng, lat];
                        this.searchMark.content = "<p>" + pos + "</p>" + "<p>" + React.language("address") + result.regeocode.formattedAddress + "</p>";
                        this.searchMark.on('click', (e) => {
                            this.infoWindow.setContent(e.target.content);
                            this.infoWindow.open(this.map, e.target.getPosition());
                        });
                        this.setState({ searchRes, searchMapList: [] })
                    } else {
                        console.error(React.language('latLon.not.exist'), status, result)
                        tipAlert({
                            type: "error",
                            msg: React.language("latLon.not.exist")
                        });
                    }
                });
            }
        }
    }

    create = (res, menu, cb) => {

        let that = this;
        that.popupFormPath = that.popupFormPath || [];
        let _opt = this.props;
        let d1 = {
            formId: _opt.forms[0],
            appId: _opt.appId,
            entryId: _opt.entryId,
            authGroupId: _opt.origin ? null : _opt.authGroupId,
            extDashData: _opt.extDashData,
            popupFormPath: _opt.extDashData ? null : !_opt.origin ? undefined : that.popupFormPath.concat({
                appId: _opt.appId,
                entryId: _opt.entryId,
                formId: _opt.forms[0],
                widgetId: _opt.widgetId,
                // menuId: "create",
                // menuType: 'menu',
                menuId: menu.menuId,
                menuType: menu.menuType || "datamenu"

            }),
        };
        d1 = BsyUtils.checkRefApp(d1);
        let formConfig = {};
        if (res) {
            let that = this;
            that.isSubmitData = false
            const h = res ? res.data.entry : {};

            window.FX.STATIC.appId = h.appId;
            window.FX.STATIC.entryId = h.entryId;
            window.FX.STATIC.INNERLINK = h._id;

            if (!BsyUtils.isObjectEmpty(h.href)) {
                window.FX.STATIC.FORMHREF = h.href;
            }
            else {
                window.FX.STATIC.FORMHREF = null
            }

            formConfig = {
                ...h,
                appId: h.appId,
                entryId: h.entryId,
            }
            formConfig.content.width = '80%';
            formConfig.content.name = h.name;
            formConfig.content.designDataId = res.data ? res.data.dataId : '';
            //designDataId: g ? g.dataId : '',
        }
        that.isSubmitData = false;
        let layerRef = null;
        BsyMaskLayer({
            customCls: 'fadein-right',
            onContentCreate: (ref) => {
                layerRef = ref;
                return <BsyFormPane
                    hasHeader={true}
                    width={'80%'}
                    {...d1}
                    formConfig={formConfig}
                    mode={"new"}
                    ignoreAuth={_opt.ignoreAuth}
                    ignoreOptAuth={_opt.ignoreOptAuth}
                    ignoreValidate={_opt.ignoreValidate}
                    onClose={(status, data, autoClose) => {
                        if (status) {
                            if (!cb)
                                that.reload({})
                            that.isSubmitData = true;
                        };

                        cb && cb();
                        layerRef && layerRef.close();
                    }}
                />
            }
        })

    }
    BBY_doSort = () => {

        let e = this
        let i = null
        let a = new window.FX.ConfirmDialog({
            title: React.language("dash.sort.setting"),
            width: 600,
            text4Ok: React.language("sort"),
            hasSeparator: !0,
            onContentCreate: function (t) {
                i = t
            },
            onOk: function () {
                e.setState({
                    defaultSort: n.getSorts(),
                }, () => {
                    e.loadData(!0)
                })
                a.close();
            }
        });
        a.show();
        let n = new window.FX.DashSortPane({
            renderEl: i,
            fields: this.state.fields,
            sorts: this.state.defaultSort,
        })
    }

    doDeleteData = (a, cb) => {
        var b = this.props
            , c = this;
        const FX = window.FX;
        const $ = window.$;
        var _this = this;
        var d = {
            appId: b.appId,
            entryId: b.entryId,
            formId: b.forms[0],
            idList: a,
            popupFormPath: b.popupFormPath.concat({
                appId: b.appId,
                entryId: b.entryId,
                formId: b.forms[0],
                widgetId: b.widgetId,
                menuType: b.menuType || 'datamenu'
            }),
        };
        if (FX.Utils.isObjectEmpty(a)) {
            tipAlert({
                type: "warning",
                msg: React.language("no.data.selected")
            })
            return;
        }

        d = FX.Utils.checkRefApp(d);
        FX.Utils.dataAjax({
            url: "/data/remove",
            data: d
        }, function (data) {
            if (data.msg) {
                //给后端_form事件用  返回真的时候有提示信息也要提示 zhxj 19521
                tipAlert({
                    type: "success",
                    msg: data.msg
                })
            }
            cb && cb();
        })
    }

    _doShowData = (e, type, noSwitchBtn, animation, lowLayer) => {
        const FX = window.FX;
        const $ = window.$;
        var i = this.getDataByIdx(e);
        this._dataIndex = e;
        let that = this;
        let extDashData = {
            appId: this.props.appId,
            entryId: this.props.entryId,
            formId: this.props.forms[0],
            widgetId: this.props.widgetId,
        }
        var layerRef = null;
        if (i) {
            var a = this
                , n = this.props
                , s = i._id
                , o = this.state.headerList;
            var r = $('<div class="x-window-mask modal light"/>').css({
                "z-index": FX.STATIC.zIndex++
            });
            var f = i._id
            var b = e;
            var hasCopy = i.dataPerms ? i.dataPerms.copy : false;
            var hasEditBtn = i.dataPerms ? i.dataPerms.update : n.itemEditable,
                hasDeleteBtn = i.dataPerms ? i.dataPerms.delete : n.itemRemovable,
                hasLog = i.dataPerms ? i.dataPerms.log : n.itemLog,
                hasComment = i.dataPerms ? i.dataPerms.comment : n.itemComment,
                flow_log = i.dataPerms ? i.dataPerms.flow_log : n.flow_log;

            if (a.reftype == 'etl_table' || a.reftype == 'aggregate_table') {

                let config = {
                    appId: n.appId,
                    formId: n.forms[0],
                    entryId: n.entryId,
                    origin: "report",
                    originPrint: "report",
                    ptlist: [],
                    widgetId: n.widgetName,
                    hasFlowLog: flow_log,
                    hasLogView: flow_log,
                    hasFlowBtn: flow_log,
                    hasShareBtn: !1,
                    width: 1080,
                    forms: n.forms,
                    header: a._parseFieldLabelFormat(o),
                    data: i,
                    multiTabs: null,
                    dataId: i._id,
                    optAuth: i.optAuth,
                    title: n.title,
                    sourceType: n.type,
                    height: "100%",
                    // hasShareBtn: !1,
                    dataIndex: e + 1,
                    hasSwitchBtn: !noSwitchBtn,
                    hasPrintBtn: !0,
                    hasCustomPrint: !0,
                    dataCount: a.state.dataList.length,
                    hasEditBtn: hasEditBtn,
                    hasDeleteBtn: hasDeleteBtn,
                    dataPerms: i.dataPerms,
                    hasLog: n.isEtlTable ? false : hasLog,
                    hasComment: n.isEtlTable ? false : hasComment,
                    onSwitchData: function (a, b) {
                        let c = that.getDataByIdx(a - 1)
                        return c;
                    },
                }
                BsyMaskLayer({
                    customCls: animation ? 'fadein-right' : '',
                    onContentCreate: (ref) => {
                        layerRef = ref;

                        return <BsyFormPane
                            {...config}
                            mode={'view'}
                            entrance={"report"}
                            onClose={(status, reshow) => {
                                layerRef && layerRef.close();
                                if (status) {
                                    that.setState({
                                        // skip: 0,
                                    }, () => {
                                        that.loadWidget();
                                    })
                                }
                            }}
                        />

                    }
                })
                lowLayer && lowLayer.close();

                return;
            }


            // if (n.popupFormPath[0]) {
            //     n.popupFormPath[0].menuType = "datamenu";
            // }
            var d1 = BsyUtils.checkRefApp({
                appId: n.appId,
                entryId: n.entryId,
                formId: n.forms[0],
                dataId: f,
                iseditable: !1,
                fields: n.fields,
                formulas: n.formulas,
                popupFormPath: n.popupFormPath.concat({
                    appId: n.appId,
                    entryId: n.entryId,
                    formId: n.forms[0],
                    widgetId: n.widgetId,
                }),
            });
            if (this.props.widgetId) {
                d1 = { ...d1, widgetId: this.props.widgetId };
            }
            const { restore } = BsyUtils.globalIdManager(d1.appId, d1.entryId);
            FX.Utils.dataAjax({
                url: "/data/read",
                data: d1
            }, function (g) {

                var fieldtabs = {};
                FX.Utils.forEach(g.form.items, function (a1, b1) {
                    if (b1.tab)
                        fieldtabs[b1.widget.widgetName] = b1.tab
                })
                var newdata = {};
                var fields = [];
                var o1 = a._parseFieldLabelFormat(o, g.form.items);
                FX.Utils.forEach(o1, function (a1, b1) {
                    var tmpdata = $.extend({}, b1);

                    if (["dataload", 'button'].indexOf(b1.type) > -1) {
                        return !0;
                    }

                    if (fieldtabs.hasOwnProperty(b1.name)) {
                        tmpdata.tab = fieldtabs[b1.name];
                    }
                    fields.push(tmpdata);
                    newdata[b1.tag] = g.data[b1.name];
                })
                newdata["_id"] = g.data["_id"];
                if (g.hasCoop || !g.hasFlow) {
                    flow_log = !1;
                }
                if (flow_log) {
                    newdata["flowStack"] = g.data["flowStack"];
                    newdata["flowState"] = g.data["flowState"];
                    newdata["chargers"] = g.data["chargers"];
                    newdata["flowVer"] = g.data["flowVer"];
                }
                newdata = $.extend(newdata, g.data);
                newdata.optAuth = i.optAuth;
                let config = {
                    appId: d1.appId,
                    formId: d1.formId,
                    entryId: d1.entryId,
                    refAppId: d1.refAppId,
                    form: g.form,
                    items: g.form.items,
                    fieldShowRules: g.form.fieldShowRules,
                    subformFieldShowRules: g.form.subformFieldShowRules,
                    is_dock_form: g.is_dock_form,
                    origin: "report",
                    originPrint: "report",
                    widgetId: n.widgetName || a.props.widgetId,
                    rawdata: a.props.rawdata,
                    extDashData: a.props.rawdata ? extDashData : null,
                    ptlist: n.isEtlTable ? [] : i.dataPerms && i.dataPerms.ptlist,
                    hasFlowLog: flow_log,
                    hasLogView: flow_log,
                    hasFlowBtn: flow_log,
                    hasShareBtn: !1,
                    sourceType: n.type,
                    hasCopy: hasCopy,
                    width: 1080,
                    forms: n.forms,
                    header: fields,
                    allShowFields: o1,
                    data: newdata,
                    optAuth: i.optAuth,
                    multiTabs: g.formTabs,
                    formTabsStyle: g.formTabsStyle || {},
                    dataId: g.data._id,
                    title: n.title,
                    height: "100%",
                    // hasShareBtn: !1,
                    dataIndex: e + 1,
                    hasSwitchBtn: !noSwitchBtn,
                    hasPrintBtn: !0,
                    hasCustomPrint: !0,
                    dataCount: a.state.dataList.length,
                    hasEditBtn: hasEditBtn,
                    hasDeleteBtn: hasDeleteBtn,
                    dataPerms: i.dataPerms,
                    hasLog: n.isEtlTable ? false : hasLog,
                    hasComment: n.isEtlTable ? false : hasComment,
                    popupFormPath: n.popupFormPath.concat({
                        appId: n.appId,
                        entryId: n.entryId,
                        formId: n.forms[0],
                        widgetId: n.widgetId,
                    }),
                    onSwitchData: function (a, b) {
                        let c = that.getDataByIdx(a - 1)
                        return c;
                    },
                    onDeleteData: function () {
                        BsyAlert({
                            title: React.language("del.data.tip"),
                            type: "error",
                            text4Ok: React.language("ok"),
                            text4Cancel: React.language("cancel"),
                            OkType: "red",
                            ok: function () {
                                that.doDeleteData(f, () => {
                                    that.loadData()
                                    restore();
                                    layerRef && layerRef.close();
                                });

                            }
                        })
                    },
                }
                let layerRef = null;
                BsyMaskLayer({
                    customCls: 'fadein-right',
                    onContentCreate: (ref) => {
                        layerRef = ref;
                        return <BsyFormPane
                            {...config}
                            mode={'view'}
                            entrance={"report"}
                            onClose={status => {
                                restore();
                                layerRef && layerRef.close();
                                if (status) {
                                    that.loadData()
                                }
                            }}
                        />

                    }
                })


            }, function () {
                restore();
                // layerRef && layerRef.close();
                return !1;
            }, function () {
                restore();
                // layerRef && layerRef.close();
            })
        }
    }

    _parseFieldLabelFormat = (e, orgds) => {
        const FX = window.FX;
        const $ = window.$;
        function findField(name) {
            var tag = {};
            FX.Utils.forEach(orgds, function (index, data) {
                if (data.widget.widgetName == name) {
                    tag = $.extend(true, {}, data.widget);
                }
            })
            return tag
        }

        var i = [];
        return FX.Utils.forEach(e, function (e, a) {
            var n = {};
            if (!orgds) {
                n = $.extend({}, a);
            } else {
                if (a.type == 'linkquery') {
                    n = $.extend({}, a, findField(a.name));
                } else {
                    n = $.extend({}, a);
                }
            }
            if (FX.Utils.isNull(n.text) && (n.text = a.title),
                "subform" === a.type) {
                var s = [];
                FX.Utils.forEach(a.items, function (e, i) {
                    var a = $.extend({}, i);
                    if (FX.Utils.isNull(a.text)) {
                        a.text = i.title
                        s.push(a)
                    }
                });
                n.items = s
            }
            i.push(n)
        }),
            i
    }

    getDataByIdx = (t) => {
        const { dataList } = this.state;
        return dataList[t]
    }

    createMapTableMenu = (res, res1) => {
        const { menu, onRowMenuEvent } = this.props;

        const { dataList, headerList } = this.state;
        let css = {}
        let menuFlag = !res.dataPerms || !res.dataPerms.menu || !res.dataPerms.menu[res1.menuId]
        if (menuFlag) {
            css = { color: '#aaa', cursor: "no-drop" }
        } else {
            css = { "color": res1.color, cursor: "pointer" }
        }
        return (
            <>
                {
                    res1.mode === 'text' ? <span
                        data-tip={res1.tip}
                        data-place={"bottom"}
                        data-type={window.mode}
                        data-html={!!res1.tip}
                        style={css}
                        className="item"
                        title={res1.tip}
                        onClick={(e) => {
                            e.stopPropagation()
                            if (!menuFlag) {
                                let rowdata = { ...res }
                                if (typeof onRowMenuEvent === 'function')
                                    onRowMenuEvent(res1, rowdata, this.reftype, e)
                            }

                            // !menuFlag && _menuBatchEvnet(res1.menuId, !1, [res._id], headerList, res, false, res1, true, 'datamenu')
                        }}>
                        {res1.name}
                    </span> : <i
                        data-tip={res1.tip}
                        data-place={"bottom"}
                        data-type={window.mode}
                        data-html={!!res1.tip}
                        style={css}
                        className={"item icon-bby-reportmenu-" + res1.icon}
                        title={res1.tip}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (!menuFlag) {
                                let rowdata = { ...res }
                                if (typeof onRowMenuEvent === 'function')
                                    onRowMenuEvent(res1, rowdata, this.reftype, e)
                            }
                            // !menuFlag && _menuBatchEvnet(res1.menuId, !1, [res._id], headerList, res, false, res1, true, 'datamenu')
                        }}></i>
                }
            </>
        )
    }

    switchWindow = () => {
        const { dataWindowOpen } = this.state;
        this.setState({ dataWindowOpen: !dataWindowOpen })
    }

    locaitonAddress = (val, key) => {
        return () => {
            const AMap = this.AMap;
            let { markerList, dataList, LngLats } = this.state;
            if (!LngLats[key]) {
                tipAlert({
                    type: 'warning',
                    msg: React.language('latLon.empty.tip')
                })
                return
            }
            if (LngLats[key][0] <= -500 && LngLats[key][1] <= -500) {
                tipAlert({
                    type: 'warning',
                    msg: React.language('latLon.empty.tip')
                })
                return
            }
            dataList.map((res) => {
                res.locationSelect = false;
            })
            dataList[key].locationSelect = true;

            markerList.map((res) => {
                res.setIcon(icon1);
                if (this.hasDetail) {
                    let cont = res.getLabel().content;
                    let scont = cont;
                    if (cont.split('class="marker-route marker-marker-bus-from active"').length > 1) {
                        scont = cont.split('class="marker-route marker-marker-bus-from active"').join('class="marker-route marker-marker-bus-from"')
                    }
                    res.setLabel({
                        offset: new AMap.Pixel(0, -15), // 相对于基点的偏移位置
                        direction: "top",
                        content: scont,  // 自定义点标记覆盖物内容
                    });
                }
                res.setzIndex(12)
            })
            if (this.hasDetail) {
                let cont = markerList[key].getLabel().content;
                let scont = cont;
                if (cont.split('class="marker-route marker-marker-bus-from"').length > 1) {
                    scont = cont.split('class="marker-route marker-marker-bus-from"').join('class="marker-route marker-marker-bus-from active"')
                }
                markerList[key].setLabel({
                    offset: new AMap.Pixel(0, -15), // 相对于基点的偏移位置
                    direction: "top",
                    content: scont,  // 自定义点标记覆盖物内容
                });
            }

            markerList[key].setIcon(icon2);

            markerList[key].setzIndex(13)
            this.map.panTo(LngLats[key]);
            this.setState({ dataList })
        }
    }

    setMapField = (k) => {
        return () => {
            const { searchRes, dataList } = this.state;
            const { mapfields } = this.props;
            const d = this.props;
            if (BsyUtils.isObjectEmpty(searchRes)) {
                tipAlert({
                    type: "warning",
                    msg: React.language('dash.map.marker.empty.tip')
                });
                return
            }
            searchRes.time = new Date().getTime();
            if (d.popupFormPath[0]) {
                d.popupFormPath[0].menuType = 'datamenu'
            }
            React.axios('/data/reportevent', {
                widgetAlias: d.widgetNameAlias ? d.widgetNameAlias : d.widgetName,
                entryId: d.entryId,
                formId: d.forms[0],
                popupFormPath: d.popupFormPath.concat({
                    appId: d.appId,
                    entryId: d.entryId,
                    formId: d.forms[0],
                    widgetId: d.widgetId,
                }),
                data: {
                    itemManualData: searchRes,
                    currentSel: {
                        dataid: dataList[k]._id
                    },
                    type: mapfields.length > 0 ? mapfields[0].type : "",
                    DataMode: d.DataMode,
                }
            }).then((res) => {
                let a = res.data;
                if (a.code) {
                    tipAlert({
                        type: "error",
                        msg: a.msg
                    });
                } else {
                    tipAlert({
                        type: "success",
                        msg: React.language('print.usage.set')
                    });
                    if (this.searchMark) {
                        this.searchMark.setMap(null);
                        this.searchMark = null;
                    }
                    this.setState({ searchRes: {} }, () => {
                        this.reload();
                    })
                }

            })
        }
    }

    render() {
        const { itemDataable, itemSeleable, mapfields, onSwitchButton, menu } = this.props;
        const { searchMapList, dataWindowOpen, dataList, headerList, isLoading, hasAMap } = this.state;
        if (!hasAMap) {
            return BsyUtils.AmapError();
        }
        return (
            <div className="BsyDashMap">
                {
                    isLoading ? <BsySLoading mode={'skeletonspin'} /> : ''
                }
                <div className="dash-map-cont" id={"DashMap-" + window.zIndex}>

                </div>
                <div className="dash-map-panel" id={"map-panel-" + window.zIndex}>

                </div>
                {itemDataable && <div className="dash-map-data-window" style={{ height: dataWindowOpen ? "" : "36px" }}>
                    <div className="map-data" onClick={this.switchWindow}>
                        <div className="map-data-title">
                            <span className="data-title">{React.language('dash.map.window.title')}</span>
                            <span className="data-msg">({React.language('map.data.num', { num: dataList.length })})</span>
                        </div>
                        <i className={dataWindowOpen ? "icon-bby-menuUp" : "icon-bby-menuDown"}></i>
                    </div>
                    {dataWindowOpen && <div className="map-data-list">
                        {
                            dataList.map((res, key) => {
                                return <div className="map-data-item">
                                    <div className="item-data-content">
                                        <div className="item-header">
                                            <div className="info-btn">
                                                <div className="map-btn" onClick={() => {
                                                    this._doShowData(key, 'newMap')
                                                }}>
                                                    {React.language('view')}
                                                </div>
                                                <div className={"map-btn " + (res.locationSelect ? "active" : "")} onClick={this.locaitonAddress(res, key)}>
                                                    {React.language('widget.location')}
                                                </div>
                                                {
                                                    (onSwitchButton && ((!res.dataPerms || res.dataPerms.setLAL))) && <div className="map-btn" onClick={this.setMapField(key)}>
                                                        {React.language('map.set.coordinates')}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="item-body">
                                            {
                                                headerList.map((res1) => {
                                                    let row = BsyUtils.transformDataSourceRow(res1, res[res1.tag]);
                                                    if (!res.hasOwnProperty(res1.tag)) {
                                                        row = ""
                                                    }
                                                    if (res1.type === 'chargers') {

                                                        let content1 = React.language('flow.charger.current') + "：" + (row ? row.currentcharger.join('、') : '');
                                                        let content2 = React.language('flow.node.current') + "：" + (row ? row.currentnode.join('、') : '');

                                                        return <>
                                                            <div className="item-body-line">
                                                                <div className="field-icon">
                                                                    <i className={'icon-bsy-dangqianjiedian'}></i>
                                                                </div>
                                                                <div className="field-cont">
                                                                    {content2}
                                                                </div>
                                                            </div>
                                                            <div className="item-body-line">
                                                                <div className="field-icon">
                                                                    <i className={BsyUtils._getFieldTypeIcon(res1.type)}></i>
                                                                </div>
                                                                <div className="field-cont">
                                                                    {content1}
                                                                </div>
                                                            </div>
                                                        </>
                                                    }

                                                    let content = res1.title + "：" + row;
                                                    return res1.type !== "menu" && !res1.detailOnly && <div className="item-body-line">
                                                        <div className="field-icon">
                                                            <i className={BsyUtils._getFieldTypeIcon(res1.type)}></i>
                                                        </div>
                                                        <div className="field-cont">
                                                            {content}
                                                        </div>
                                                    </div>
                                                })
                                            }

                                        </div>
                                        <div className="item-footer">
                                            {(menu && menu.enable) && <div className="table_menu">
                                                {
                                                    menu.set.map((res2) => {
                                                        return this.createMapTableMenu(res, res2)
                                                    })
                                                }
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>}
                </div>}
                {itemSeleable && <div className="dash-map-search">
                    <div className="map-search-input">
                        <input type="text" ref={this.searchInput} placeholder="搜索定位中心" onChange={this.onSearchMap} />
                        <i className="icon-bsy-reportmenu-0"></i>
                    </div>
                    {searchMapList.length > 0 && <ul className="location-tip">
                        {
                            searchMapList.map((res) => {
                                return <li className="search-item" onClick={this.setZoom(res)}>
                                    <div className="item-name">
                                        {res.name}
                                    </div>
                                    <div className="item-district">
                                        {res.district}
                                    </div>
                                </li>
                            })
                        }
                    </ul>}
                </div>}
            </div>
        );
    }
}

export default BsyDashMap;
